export const paths = {
  account: {
    index: '/account',
  },
  buildOptions: {
    index: '/build-options',
  },
  connect: {
    index: '/connect',
  },
  dashboard: {
    index: '/',
  },
  deployments: {
    index: '/deployments',
  },
  environments: {
    add: '/environments/add',
    edit: '/environments/edit/:id',
    index: '/environments',
  },

  formSubmissions: {
    index: '/form-submissions',
  },
  forms: {
    index: '/forms',
  },
  github: {
    index: '/github',
  },
  search: {
    index: '/search',
  },
  support: {
    docs: 'https://staticsnap.com/docs/',
  },
  websites: {
    index: '/websites',
  },
};
